import SearchForm from './SearchForm';

export default SearchForm;